/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlersWindVelocityHeader } from './HandlersWindVelocityHeader';
import {
    HandlersWindVelocityHeaderFromJSON,
    HandlersWindVelocityHeaderFromJSONTyped,
    HandlersWindVelocityHeaderToJSON,
} from './HandlersWindVelocityHeader';

/**
 * 
 * @export
 * @interface HandlersWindVelocityRecord
 */
export interface HandlersWindVelocityRecord {
    /**
     * 
     * @type {Array<number>}
     * @memberof HandlersWindVelocityRecord
     */
    data?: Array<number>;
    /**
     * 
     * @type {HandlersWindVelocityHeader}
     * @memberof HandlersWindVelocityRecord
     */
    header?: HandlersWindVelocityHeader;
}

/**
 * Check if a given object implements the HandlersWindVelocityRecord interface.
 */
export function instanceOfHandlersWindVelocityRecord(value: object): boolean {
    return true;
}

export function HandlersWindVelocityRecordFromJSON(json: any): HandlersWindVelocityRecord {
    return HandlersWindVelocityRecordFromJSONTyped(json, false);
}

export function HandlersWindVelocityRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandlersWindVelocityRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'header': json['header'] == null ? undefined : HandlersWindVelocityHeaderFromJSON(json['header']),
    };
}

export function HandlersWindVelocityRecordToJSON(value?: HandlersWindVelocityRecord | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'],
        'header': HandlersWindVelocityHeaderToJSON(value['header']),
    };
}

